<svg
  xmlns="http://www.w3.org/2000/svg"
  fill="none"
  viewBox="0 0 16 16"
  stroke="var(--stroke-color)"
  [attr.width]="width"
  [attr.height]="height"
>
  <path
    d="M11.3332 4.66699L4.6665 11.3337M4.6665 4.66699L11.3332 11.3337"
    stroke="var(--stroke-color)"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
